import React, { Fragment } from 'react';
import { folder } from 'helper/constant';
import { onlyDate } from "helper/methods";
import { 
    table,
} from 'helper/constant';

const FileRow = ({ 
    media, 
    type, 
    openFileORFolder
}) => {

    return (
        <tr className="folder-row">
            <td className="folder-name fs-15 medium-text" onClick={() => openFileORFolder(media, type)}>
                {
                    type === "folder" ?
                    <Fragment>
                        <img src={folder} alt="file"/>
                        { media.name.length > 16 ? media.name.substring(0, 15)+'...' : media.name }
                    </Fragment> :
                    <Fragment>
                        <img className="border-radius-6" src={table} alt="file"/>
                        { media.name.length > 16 ? media.name.substring(0, 15)+'...' : media.name }
                    </Fragment>
                }
            </td>
            <td>
                <div className="more-options">
                    {/*
                    <CSVLink 
                        data={[]}
                        headers={[]} 
                        filename={""}
                        className="btn c-primary"
                        target="_blank"
                        style={{textAlign:"center"}}
                        onClick={(e) => downloadMedia(e, media, type)}

                    >
                        İndir
                    </CSVLink>
                    */}

                </div>
            </td>
        </tr>
    );
};

export default FileRow;